<div class="modal-header bg-primary text-white rounded-top">
  <h5 class="modal-title w-100 text-center">{{ title }}: {{ user?.name }}
    @if (selectedOrgName) {
      <span>of {{ selectedOrgName }}</span>
    }
  </h5>
  <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body d-flex flex-column" style="height: 400px;">

  <!-- Org Selection -->
  @if (isOrgVisible && !selectedOrg) {
    <div class="text-center my-3">
      <h6 class="mb-3">Select organization that is sending the message</h6>
      <select class="form-select w-75 mx-auto" [(ngModel)]="selectedOrg" (change)="selectOrg(selectedOrg)">
        @for (org of organizationsList; track org) {
          <option [value]="org.id">{{ org.name }}</option>
        }
      </select>
      @if (selectedOrg) {
        <p class="mt-2 text-muted">
          Selected organization: <strong>{{ selectedOrg }}</strong>
        </p>
      }
    </div>
  }

  <!-- Chat Messages -->
  @if (selectedOrg) {
    <div class="flex-grow-1 overflow-auto mb-3 p-2 border rounded bg-light" id="chatBox">
      @for (msg of messageListFull; track msg) {
        <div>
          <div [ngClass]="{'d-flex justify-content-end': msg.isMe, 'd-flex justify-content-start': !msg.isMe}">
            <div class="chat-bubble p-2 px-3"
              [ngClass]="msg.isMe ? 'bg-primary text-white rounded-start-3 rounded-top-3' : 'bg-white border rounded-end-3 rounded-top-3 shadow-sm'">
              <!-- Single header line -->
              <p class="mb-1 fw-semibold small">
                {{ msg.from }}
                @if (msg.fromOrgName) {
                  <span> | {{ msg.fromOrgName }}</span>
                }
                | {{ msg.localTime }}
              </p>
              <!-- Message text -->
              <p class="mb-1" [innerHTML]="msg.text"></p>
            </div>
          </div>
          <div class="my-2"></div>
        </div>
      }
      @if (messageListFull.length === 0) {
        <div class="text-center text-muted">
          No messages yet.
        </div>
      }
    </div>
  }

  <!-- Input -->
  @if (selectedOrg) {
    <div class="input-group">
      <textarea class="form-control" placeholder="Type a message..." [(ngModel)]="newMessage"
      (keydown)="onEnter($event)"></textarea>
      <button class="btn btn-primary" (click)="sendMessage()" [disabled]="!newMessage.trim()">
        <i class="bi bi-send-fill"></i>
      </button>
    </div>
  }
</div>